export default interface CompanyFinancialDataModel {
    error: boolean;
    errorString: string;
    currentYear: BalanceSheet;
    previousYear: BalanceSheet;
    startDate: string;
    endDate: string;
    completedDate: string;
    newDocument: string;
    oldDocument: string;
    validForSubmission: boolean;
    employees: number;
    companyNumber: string;
    companyName: string;
    hasPreviousYear: boolean;
}

export interface BalanceSheet {
    year: string;
    fixedAssets: number;
    currentAssets: number;
    currentCreditors: number;
    nonCurrentCreditors: number;
    netAssets: number;
    shareCapital: number;
    retainedEarnings: number;
    totalEquity: number;
}

export const defaultFinancialData: CompanyFinancialDataModel = {
    error: false,
    errorString: '',
    currentYear: {
        year: '',
        fixedAssets: 0,
        currentAssets: 0,
        currentCreditors: 0,
        nonCurrentCreditors: 0,
        netAssets: 0,
        shareCapital: 0,
        retainedEarnings: 0,
        totalEquity: 0,
    },
    previousYear: {
        year: '',
        fixedAssets: 0,
        currentAssets: 0,
        currentCreditors: 0,
        nonCurrentCreditors: 0,
        netAssets: 0,
        shareCapital: 0,
        retainedEarnings: 0,
        totalEquity: 0,
    },
    startDate: '',
    endDate: '',
    completedDate: '',
    newDocument: '',
    oldDocument: '',
    validForSubmission: false,
    employees: 0,
    companyNumber: '',
    companyName: '',
    hasPreviousYear: false,
};

export const balanceSheetFields: { [key: string]: string[] } = {
    fixedAssets: [
        'fixedassets',
        'fixed assets',
        'tangible assets',
        'intangible assets',
        'plant and machinery',
        'accumulated depreciation',
        'property',
        'equipment',
        'investments',
        'buildings',
    ],
    currentAssets: [
        'current assets',
        'cash',
        'receivable',
        'called up share capital not paid',
        'debtors',
        'prepayments',
        // 'accrued income',
        'inventory',
        'inventories',
        'trade and other receivables',
        'stocks',
    ],
    currentCreditors: [
        'accounts payable',
        'trade creditors',
        'due within one',
        'due in one',
        'other creditors',
        'vat payable',
        'corporation tax',
        // 'accruals',
        'accrued expenses',
        'deferred income',
        'income in advance',
        'other payable',
    ],
    nonCurrentCreditors: [
        'due after one',
        'due after more',
        'provision for liabilities',
        'provisions for liabilities',
        'loans',
    ],
    netAssets: ['net assets'],
    shareCapital: ['shares', 'share capital', 'share account', 'share premium', 'capital redemption'],
    retainedEarnings: [
        'other reserves',
        'profit and loss',
        'retained profits',
        'retained earnings',
        'dividends',
    ],
    totalEquity: ['capital and reserves', 'shareholders', 'shareholder funds', 'total equity'],
};
